module.exports = new __parcel__URL__("TeamAppTile.eb507a2b.svg").toString();